import { Box, type BoxProps } from '@apia/theme';
import { useAccordionContext } from './context';
import { getVariant } from '@apia/theme';
import { useCallback } from 'react';

export const KeyHandler = (props: BoxProps) => {
  const handler = useAccordionContext();

  const variant = handler.hooks.usePropsSelector((current) => current.variant);

  return (
    <Box
      {...props}
      ref={useCallback(
        (ref: HTMLElement | null) => {
          if (ref) {
            ref.addEventListener('keydown', (ev) => {
              if (
                (ev.target as HTMLElement).closest('.accordion__item__content')
              )
                return;

              const accordionItem = (ev.target as HTMLElement)?.closest(
                '.accordion__item',
              ) as HTMLElement;
              const accordion = (ev.target as HTMLElement)?.closest(
                '.accordion',
              );
              const allItems = [
                ...(accordion?.querySelectorAll('.accordion__item') ?? []),
              ];
              const currentIndex = allItems.findIndex(
                (current) => current === accordionItem,
              );

              if (ev.code === 'ArrowDown') {
                if (currentIndex < allItems.length - 1) {
                  ev.preventDefault();
                  (
                    (allItems[currentIndex + 1] as HTMLElement)?.querySelector(
                      '.accordion__item__button',
                    ) as HTMLElement
                  )?.focus();
                }
              } else if (ev.code === 'ArrowUp') {
                if (currentIndex > 0) {
                  ev.preventDefault();
                  (
                    (allItems[currentIndex - 1] as HTMLElement)?.querySelector(
                      '.accordion__item__button',
                    ) as HTMLElement
                  )?.focus();
                }
              } else if (ev.code === 'ArrowLeft') {
                if (
                  (allItems[currentIndex] as HTMLElement)?.querySelector(
                    '[aria-expanded="true"]',
                  ) as HTMLElement
                ) {
                  ev.preventDefault();
                  (
                    (allItems[currentIndex] as HTMLElement)?.querySelector(
                      '.accordion__item__button',
                    ) as HTMLElement
                  )?.click();
                }
              } else if (ev.code === 'ArrowRight') {
                if (
                  (allItems[currentIndex] as HTMLElement)?.querySelector(
                    '[aria-expanded="false"]',
                  ) as HTMLElement
                ) {
                  ev.preventDefault();
                  (
                    (allItems[currentIndex] as HTMLElement)?.querySelector(
                      '.accordion__item__button',
                    ) as HTMLElement
                  )?.click();
                }
              } else if (ev.code === 'Space') {
                ev.preventDefault();
                ev.stopPropagation();
                const id = accordionItem.dataset.id as string;
                handler.udpateItem(id, {
                  isChecked: !handler.itemsState[id].isChecked,
                });
              }
            });
          }
        },
        [handler],
      )}
      {...(variant ? getVariant(variant) : undefined)}
    />
  );
};
